import { useEffect, useState } from "react";
import "./dashboard.css";
import GroupedDiseasesByCountry from "./charts/diseases_by_country";
import GroupedFarmsByCountry from "./charts/farm_by_country";
import DiseaseByMonth from "./charts/disease_by_month";
import FarmByProjects from "./charts/farms_by_projects";
import UsersByMonth from "./charts/users_by_month";
import GroupedUsersByCountry from "./charts/users_by_country";

export default function Dashboard() {
  const [all_diseases, setAllDiseases] = useState([]);
  const [all_farms, setAllFarms] = useState([]);
  const [price_alerts, setPriceAlerts] = useState([]);
  const [projects, setProjects] = useState([]);
  const [countryGroupedDiseases, setCountryGroupedDiseases] = useState({});
  const [countryGroupedFarms, setCountryGroupedFarms] = useState({});
  const [diseaseByMonth, setDiseaseByMonth] = useState({});
  const [groupedFarmsByProjectsNumber, setGroupedFarmsByProjectsNumber] = useState({});
  const [groupedUsersByCountry, setGroupedUsersByCountry] = useState({});
  const [groupedUsersByMonth, setGroupedUsersByMonth] = useState({});
  const [users, setUsers] = useState([]);
  const localhost = process.env.REACT_APP_LOCALHOST;
  const production = process.env.REACT_APP_PRODUCTION;

  const convertMonth = (monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString('default', { month: 'short' });
    }

  // Function to group diseases by country
  const groupDiseasesByCountry = () => {
    const grouped = all_diseases.reduce((acc, disease) => {
      const country = disease.country || "N/A";
      if (!acc[country]) acc[country] = [];
      acc[country].push(disease);
      return acc;
    }, {});
    setCountryGroupedDiseases(grouped);
  };
  //function to group farms by country
  const groupFarmsByCountry = () => {
    const grouped = all_farms.reduce((acc, farm) => {
      const country = farm.country || "N/A";
      if (!acc[country]) acc[country] = [];
      acc[country].push(farm);
      return acc;
    }, {});
    setCountryGroupedFarms(grouped);
  }

  //group diseases by month using the date field
  const groupDiseasesByMonth = () => {
    const grouped = all_diseases.reduce((acc, disease) => {
      const date = new Date(disease.date._seconds * 1000 + disease.date._nanoseconds / 1000000);
      const month = convertMonth(date.getMonth() + 1); // Months are zero-based
      const year = date.getFullYear()
      if (!acc[`${month}-${year}`]) acc[`${month}-${year}`]= [];
      acc[`${month}-${year}`].push(disease);
      return acc;
    }, {});
    setDiseaseByMonth(grouped);
  }
  //group farms by projects_number
  const groupFarmsByProjectsNumber = () => {
    const grouped = all_farms.reduce((acc, farm) => {
      const projects_number = farm.projects_number || 0;
      if (!acc[projects_number]) acc[projects_number] = [];
      acc[projects_number].push(farm);
      return acc;
    }, {});
    setGroupedFarmsByProjectsNumber(grouped);
  }
  // group users by month using the date_joined field
  const groupUsersByMonth = () => {
    const grouped = users.reduce((acc, user) => {
      if(user.date_joined){
      const date =new Date(user.date_joined._seconds * 1000 + user.date_joined._nanoseconds / 1000000) || new Date();
      const month = convertMonth(date.getMonth() + 1); // Months are zero-based
      const year = date.getFullYear()
      if (!acc[`${month}-${year}`]) acc[`${month}-${year}`] = [];
      acc[`${month}-${year}`].push(user);
      }
      return acc;
    }, {});
    setGroupedUsersByMonth(grouped);
  }


  //group users by country
  const groupUsersByCountry = () => {
    const grouped = users.reduce((acc, user) => {
      const country = user.country || "N/A";
      if (!acc[country]) acc[country] = [];
      acc[country].push(user);
      return acc;
    }, {});
    setGroupedUsersByCountry(grouped);
  }

  // optional: automatically group whenever data changes
  useEffect(() => {
    if (all_diseases.length) {
      groupDiseasesByMonth();
      groupDiseasesByCountry();
    }
    if (all_farms.length) {
      groupFarmsByCountry();
      groupFarmsByProjectsNumber();
    };
    if (users.length) {
      groupUsersByCountry();
      groupUsersByMonth();
    }
  }, [all_diseases, all_farms, users]);

  useEffect(() => {
    // Fetch disease data from an API or database

    async function fetchDiseases() {

      try {
        const response = await fetch(`${production}/global/diagonized_diseases`);
        const data = await response.json();
        setAllDiseases(data);
      } catch (error) {
        console.error("Error fetching diseases:", error);
      }
    }
    async function fetchFarms() {
      try {
        const response = await fetch(`${production}/global/farms`);
        const data = await response.json();
        setAllFarms(data);
      } catch (error) {
        console.error("Error fetching farms:", error);
      }
    }
    async function fetchPriceAlerts() {
      try {
        const response = await fetch(`${production}/global/price_alerts`);
        const data = await response.json();
        setPriceAlerts(data);
      } catch (error) {
        console.error("Error fetching price alerts:", error);
      }
    }
    async function fetchUsers() {
      try {
        const response = await fetch(`${production}/global/users`);
        const data = await response.json()
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    async function getProjects() {
      try {
        const response = await fetch(`${production}/global/projects`);
        const data = await response.json();
        setProjects(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchDiseases();
    fetchFarms();
    fetchPriceAlerts();
    fetchUsers();
    getProjects();
  }, []);

  return (
    <div className="dashboard">
      <div style={{ display: "inline-flex", justifyContent: "center", alignItems: "center", }}>
        <img src="/farmpro_nobg.png" height="60px" width="60px" alt="logo" /> <h1 style={{ color: "teal" }}>FarmPro</h1>
      </div>

      <div className="cards_container">

        <div className="stats_container">
          <div style={{ fontSize: "30px", fontWeight: "bold" }}>{all_diseases.length}</div>
          <div style={{ fontWeight: "bold", margin: "0px 5px" }}>Total Diseases Diagonized</div>

        </div>
        <div className="stats_container">
          <div style={{ fontSize: "30px", fontWeight: "bold" }}>{all_farms.length}</div>
          <div style={{ fontWeight: "bold", margin: "0px 5px" }}>Total Farms</div>

        </div>
        <div className="stats_container">
          <div style={{ fontSize: "30px", fontWeight: "bold" }}>{price_alerts.length}</div>
          <div style={{ fontWeight: "bold", margin: "0px 5px" }}>Total Price Alerts</div>

        </div>
        <div className="stats_container">
          <div style={{ fontSize: "30px", fontWeight: "bold" }}>{projects.length}</div>
          <div style={{ fontWeight: "bold", margin: "0px 5px" }}>Total Projects</div>

        </div>
        <div className="stats_container">
          <div style={{ fontSize: "30px", fontWeight: "bold" }}>{users.length}</div>
          <div style={{ fontWeight: "bold", margin: "0px 5px" }}>Total Users</div>

        </div>
      </div>
      <div>
          <FarmByProjects data={groupedFarmsByProjectsNumber} />
        </div>
     
        <div>
          <DiseaseByMonth data={diseaseByMonth} />
        </div>
        
     
      <div >
        <UsersByMonth data={groupedUsersByMonth} />
      </div>
      <div>

        <GroupedDiseasesByCountry data={countryGroupedDiseases} />
      </div>
      <div>

        <GroupedFarmsByCountry data={countryGroupedFarms} />
      </div>
      <div>
      <GroupedUsersByCountry data={groupedUsersByCountry} />
      </div>
    </div>
  );
}